import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2025 Mohana Pavan Kumar Vankayala. All rights received.
    </footer>
  )
}

export default Footer;